import * as types from "../actions/actionTypes";
import AllStationApi from "../api/allStationApi";

export function getAllStations() {
    return (dispatch) => {
        dispatch({
            type: types.GET_STATIONNAME_REQUEST,
        });
        return AllStationApi.fetchAllStationNames()
            .then((response) => {
                // console.log("response", response);
                const jsonString = JSON.parse(response.stationDetails);
                let stations = [];
                let stationsdesc = [];

                // localStorage.setItem("appliedFilters", null);

                //let DepEdcMinuteDiff = [];
                // console.info("stations actions11", jsonString);
                // console.info("stations actions11", jsonString.airportList);

                let jsonStringList = jsonString.airportList;
                // console.info("jsomStringList", jsonStringList);

                jsonString.airportList.map((m) => {
                    if (m.active == "true" && m.depEdctMinutesDiff != null) {
                        stations.push(m.iataCode);
                        // console.info("m.iataCode", m.iataCode);
                    }
                });

                stations.sort((a, b) => b.localeCompare(a));

                // stationsdesc.sort((a, b) => b - a);
                //console.info("allstations after get method", stations);
                dispatch({
                    type: types.GET_STATIONNAME_SUCCESS,
                    allStations: stations,
                    JSONStringList: jsonStringList,
                });
            })
            .catch((error) => {
                dispatch({
                    type: types.GET_STATIONNAME_FAIL,
                    payload: error.message,
                });
            });
    };
}

export function setLoader(status) {
    return (dispatch) => {
        dispatch({
            type: types.FETCH_FLIGHTDETAILS_FROM_API,
            payload: status,
        });
    };
}

export function setSelectedStation(selectedStation) {
    return (dispatch) => {
        dispatch({
            type: types.SET_SELECTEDSTATION,
            selectedStation: selectedStation,
        });
    };
}
